<template>
    <div class="body">
        <div class="search-box">
            <div class="search-box-input">
<!--                <div>-->
<!--                    <span class="title">年级：</span>-->
<!--                    <el-date-picker-->
<!--                        class="search-input"-->
<!--                        v-model="searchGrade"-->
<!--                        type="year"-->
<!--                        value-format="yyyy"-->
<!--                        @change="getData"-->
<!--                        placeholder="请选择选择年级"-->
<!--                    >-->
<!--                    </el-date-picker>-->
<!--                </div>-->
                <div>
                    <span class="title" style="margin-left: 0">专业：</span>
                    <el-select @change="filterData" class="search-input" filterable clearable v-model="searchMajor" placeholder="请选择专业">
                        <el-option v-for="item in major" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
                <div>
                    <span class="title">学期：</span>
                    <el-select @change="filterData" class="search-input" clearable v-model="searchSemester" placeholder="请选择学期">
                        <el-option v-for="item in semester" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
                <div>
                    <span class="title">安排状态：</span>
                    <el-select @change="filterData" class="search-input" clearable v-model="searchArrange" placeholder="请选择状态">
                        <el-option v-for="item in arrange" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
                <div class="top-option margin-left-30">
                    <el-button class="primary-btn" @click="reset()">重置</el-button>
                    <el-button type="primary" @click="filterData" style="margin-left: 16px">查询</el-button>
<!--                    <el-button @click="isShowInput = !isShowInput">{{ !isShowInput ? '展开' : '收起' }}</el-button>-->
<!--                    <i class="el-icon-arrow-down" v-show="!isShowInput"></i>-->
<!--                    <i class="el-icon-arrow-up" v-show="isShowInput"></i>-->
                </div>
                <div style='float: right'>
                    <el-button type="primary"
                               @click="showProgress"
                    >查看进度
                    </el-button>
                </div>
            </div>
<!--            <div v-if="isShowInput">-->
<!--                <div class="search-box-input">-->
<!--                    <div>-->
<!--                        <span class="title">安排状态：</span>-->
<!--                        <el-select @change="getData" class="search-input" clearable v-model="searchArrange" placeholder="请选择状态">-->
<!--                            <el-option v-for="item in arrange" :key="item.value" :label="item.label" :value="item.value"> </el-option>-->
<!--                        </el-select>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="container">
            <div class="table-cls">
                <el-table
                    :data="tableData"
                    class="table"
                    border
                    :cell-style="{ color: '#666666', fontSize: '14px' }"
                    :header-cell-style="{ background: '#eef1f6', color: '#333333', height: '49px', fontWeight: 500, fontSize: '14px' }"
                >
                    <el-table-column prop="grade" align="center" label="年级"></el-table-column>
                    <el-table-column prop="level" align="center" label="层次"></el-table-column>
                    <el-table-column prop="major_id" align="center" label="专业">
                        <template slot-scope="scope">
                            {{ tableMajorHash[scope.row.major_id] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="semester" align="center" label="学期">
                        <template slot-scope="scope">
                            {{ semesterHash[scope.row.semester] }}
                        </template>
                    </el-table-column>
<!--                    <el-table-column prop="org" align="center" v-if="this.org == 1" label="所属院校">-->
                    <el-table-column prop="org" align="center" label="所属院校">
                        <template slot-scope="scope">
                            {{ orgHash[scope.row.org] }}
                        </template>
                    </el-table-column>
<!--                    <el-table-column prop="org" align="center" v-if="this.org == 1" label="安排状态">-->
                    <el-table-column prop="org" align="center" label="安排状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.isArrange === 1 ? 'color-blue' : 'color-red'">
                                {{ scope.row.isArrange === 1 ? '已安排' : '未安排' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="220px" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button class="primary-btn" @click="editBtn(scope.$index, scope.row)">考试安排</el-button>
                            <el-button v-if='org == 4 || org==147' class="primary-btn" :disabled='scope.row.isArrange != 1' @click="word(scope.row)">导出试卷</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    :page-size="10"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="考试安排" :visible.sync="dialogVisible" width="1220px"
                   :close-on-click-modal='false' :close-on-press-escape='false'>
            <el-table
                :data="examData"
                class="table"
                border
                empty-text="当前专业学期暂无课程信息，请先排课！"
                :cell-style="{ color: '#666666', fontSize: '14px' }"
                :header-cell-style="{ background: '#eef1f6', color: '#333333', height: '49px', fontWeight: 500, fontSize: '14px' }"
            >
                <el-table-column prop="sort_num" align="center" label="序号" width="50px"></el-table-column>
                <el-table-column prop="crs_id" align="center" width="208px" label="课程">
                    <template slot-scope="scope">
                        {{ crsDataHash[scope.row.crs_id] }}
                        <span style='color: red' v-if='scope.row.course_type === 8'>(线下课程)</span>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="考试安排" width="140px">
                    <template slot-scope="scope">
                        <el-select
                            v-model="examData[scope.$index].exam_type"
                            clearable
                            filterable
                            placeholder="请考试类型"
                            :disabled="editDisabled || scope.row.course_type === 8"
                        >
                            <el-option v-for="item in examTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="考试试题" width="240px">
                    <template slot-scope="scope">
                        <el-select
                            v-model="examData[scope.$index].ques_id"
                            clearable
                            filterable
                            placeholder="请选择试题"
                            :disabled="editDisabled || scope.row.exam_type === 1 || scope.row.course_type === 8"
                        >
                            <el-option v-for="item in scope.row.ques_data" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="org" align="center" label="考试开始时间" width="250px">
                    <template slot-scope="scope">
                        <el-date-picker
                            :disabled="editDisabled || scope.row.exam_type === 1 || scope.row.course_type === 8"
                            v-model="scope.row.exm_start"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            placeholder="选择开始时间"
                        >
                        </el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="org" align="center" label="考试结束时间" width="250px">
                    <template slot-scope="scope">
                        <el-date-picker
                            :disabled="editDisabled || scope.row.exam_type === 1 || scope.row.course_type === 8"
                            v-model="scope.row.exm_end"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm"
                            size="mini"
                            placeholder="选择结束时间"
                        >
                        </el-date-picker>
                    </template>
                </el-table-column>
            </el-table>

            <div class="btn-box">
                <div class="btn">
                    <el-button class="primary-btn" @click="cancel()">取消</el-button>
                    <el-button type="primary" @click="save()" :disabled="editDisabled">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'exam',
    data() {
        return {
            tableMajorHash:[],
            editDisabled: false,
            org: 0,
            orgHash: [],
            startTime: '',
            endTime: '',
            crsDataHash: [],
            value1: '',
            searchGrade: '',
            searchMajor: '',
            searchSemester: '',
            searchArrange: '',
            arrange: [
                { value: 0, label: '未安排' },
                { value: 1, label: '已安排' }
            ],
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            examData: [],
            isShowInput: false, // 是否展示下面的input
            form: {
                id: '',
                sort_num: '',
                crs_id: '',
                exm_start: '',
                exm_end: ''
            },
            major: [],
            majorHash: [],
            semester: [],
            semesterHash: [],
            dialogVisible: false,
            examTypeList: [],
            examHash: [],
            rules: {
                name: [{ type: 'string', required: true, message: '请输入教师姓名', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.org = localStorage.getItem('org');
        console.log('this.org', this.org);
        this.getData();
        this.getTblInfo();
        this.getTransitionValue();
        this.getCrsData();
    },
    methods: {
        filterData(){
            this.pageIndex = 1
            this.getData()
        },
        save() {
            // console.log('222222222222222222222this.examData',this.examData);

            if (this.examData.length === 0) {
                this.$message.error('当前专业学期暂未排课，请先排课！');
                return false;
            }

            let isSave = true;
            let nowTime = new Date().getTime();
            this.examData.forEach((item, index) => {
                if (!isSave) {
                    return false;
                }

                if (item.exam_type !== 1) {
                    if (!item.ques_id) {
                        isSave = false;
                        this.$message.error('请选择考试试题');
                    }

                    if (!item.exm_end || !item.exm_start) {
                        isSave = false;
                        this.$message.error('请选择考试时间');
                    }
                    let start = new Date(item.exm_start).getTime();
                    let end = new Date(item.exm_end).getTime();
                    // console.log('start',start);
                    // console.log('end',end);
                    if (start > end && isSave) {
                        isSave = false;
                        this.$message.error('考试开始时间 不能大于 考试结束时间！请重新设置！');
                    }
                }
            });
            if (!isSave) {
                return false;
            }
            this.$put(this.BASEURL + '/examination/management', { exm_list: this.examData }).then((res) => {
                if (res.code === 200) {
                    this.$message.success('保存成功！');
                    this.dialogVisible = false;
                    this.getData()
                } else {
                    console.log(res.error);
                }
            });
            // console.log('this.examDatathis.examDatathis.examData',this.examData);
        },
        //获取课程列表
        getCrsData() {
            this.$get(this.BASEURL + '/tution/course/GET').then((res) => {
                if (res.code === 200) {
                    let hash = [];
                    res.crsData.forEach((item, index) => {
                        hash[item.id] = item.name;
                    });
                    this.crsDataHash = hash;
                    // console.log('this.crsDataHash',this.crsDataHash);
                } else {
                    console.log(res.error);
                }
            });
        },
        editBtn(index, data) {
            if (data.org != this.org) {
                this.editDisabled = true;
            }
            this.getExamMsg(data);
            this.dialogVisible = true;
        },
        cancel() {
            this.dialogVisible = false;
        },
        getData() {
            this.$get(
                this.BASEURL +
                    `/examination/management?option=1&page=${this.pageIndex}&major=${this.searchMajor}&semester=${this.searchSemester}&grade=${this.searchGrade}&isArrange=${this.searchArrange}`
            ).then((res) => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    console.log('222222222222', this.tableData);
                    this.pageTotal = res.total;
                } else {
                    console.log(res.error);
                }
            });
        },
        getExamMsg(data) {
            this.$get(this.BASEURL + `/examination/management?option=2&page=1&id=${data.id}&major_id=${data.major_id}`).then((res) => {
                if (res.code === 200) {
                    this.examData = res.data;
                    console.log('this.examData', this.examData);
                } else {
                    console.log(res.error);
                }
            });
        },
        //获取select值
        getTblInfo() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [
                    ['id', 'grade,level,name', 'major_base_t'],
                    ['org', 'org_name', 'academy_base_t'],
                    ['id', 'name', 'major_base_t'],
                ],
                state: 1
            }).then((res) => {
                if (res.code === 200) {
                    this.major = res.data[0][0];
                    this.majorHash = res.data[0][1];
                    this.orgHash = res.data[1][1];
                    this.tableMajorHash = res.data[2][1];
                    console.log('this.major', this.orgHash);
                } else {
                    console.log(res.error);
                }
            });
        },
        getTransitionValue() {
            let data = ['major_semester', 'exam_type'];
            this.$post(this.BASEURL + '/assets/transition/GET', {
                key_list: data
            }).then((res) => {
                if (res.code === 200) {
                    this.semester = res.data.major_semester[0];
                    this.semesterHash = res.data.major_semester[1];
                    this.examTypeList = res.data.exam_type[0];
                    this.examHash = res.data.exam_type[1];
                    console.log('3333333333333333333333333', res.data);
                } else {
                    console.log(res.error);
                }
            });
        },
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        reset() {
            this.searchGrade = '';
            this.searchMajor = '';
            this.searchSemester = '';
            this.searchArrange = '';
            this.getData();
        },
        word(row){
            let data = {
                grade : row.grade,
                semester_id: row.id,
                level:row.level,
                major_id:row.major_id,
                semester:row.semester
            };
            this.$post(this.BASEURL + '/examination/examword', data).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                } else {
                    console.log(res.error);
                }
            });
        },
        showProgress() {
            this.$router.push({ path: '/task' });
        },
    }
};
</script>

<style lang="scss" scoped>
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}

.search-box {
    background-color: #ffffff;
    /*justify-content: space-between;*/
    padding: 28px 30px;
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;
    min-width: 1000px;
    .search-box-input {
        display: flex;
        margin-bottom: 15px;
    }
    .search-box-input>div {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        text-align: right;
        width: 24%;
        min-width: 210px;
        span {
            margin-left: 20px;
        }
        .search-input {
            flex-grow: 1;
        }
        &:nth-of-type(4){
            width: 200px;
        }
    }
    .top-option {
        .el-icon-arrow-up, .el-icon-arrow-down {
            color: #20a0ff;
        }
        .el-button:nth-of-type(3) {
            color: #20a0ff;
            background-color: rgba(0, 0, 0, 0);
            margin-right: 5px;
            border: 0;
            margin-left: 10px;
            padding: 0;
        }
    }
    .title {
        font-size: $title-size;
        line-height: 15px;
        color: #343434;
    }
}

.primary-btn {
    border-color: #409eff;
    color: #409eff;
}
.btn-box {
    margin-top: 40px;
    zoom: 1;
    .btn {
        float: right;
        overflow: hidden;
    }
}
.btn-box:after {
    content: '020';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
</style>
